// src/pages/dashboard/WalletStats.jsx
import React from 'react';

const WalletStats = () => {
  return (
    <div className="bg-[#0B3A32] p-6 rounded-xl shadow-lg">
      <h2 className="text-xl font-semibold text-[#CE9242] mb-2">💼 Wallet Statistics</h2>
      <p className="text-sm text-gray-300 mb-4">
        View your current token holdings, wallet balance, and value in USD.
      </p>

      {/* Placeholder for wallet stats */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="bg-[#062925] p-4 rounded-md">
          <p className="text-gray-400 text-sm">USDT Balance</p>
          <p className="text-lg font-bold text-white">2,438.73</p>
        </div>
        <div className="bg-[#062925] p-4 rounded-md">
          <p className="text-gray-400 text-sm">VTX Tokens</p>
          <p className="text-lg font-bold text-white">128,000</p>
        </div>
      </div>
    </div>
  );
};

export default WalletStats;
